module.exports = __webpack_public_path__ + "img/gygx_07.ee52d51b.jpg";